import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="无遮韩国免费漫画大全 - 免费在线阅读韩漫的首选韩漫漫画网站。提供最全面的韩国漫画资源，高清画质，每日更新，网站稳定性高确保访问顺畅。涵盖恋爱、奇幻、热血、搞笑、悬疑等多种分类。"
        keywords="无遮韩国免费漫画大全,免费在线阅读韩漫,韩漫漫画网站,韩国漫画,免费漫画,韩漫在线阅读"
        canonicalUrl="/"
      />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedComics />
          <HotRanking />
          <LatestUpdates />
          <ArticleSection />
          <FAQSection />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-primary-500">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-3">
                开始您的韩漫阅读之旅
              </h2>
              <p className="text-sm text-background-50/85 mb-6">
                加入百万韩漫爱好者社区，在无遮韩国免费漫画大全畅享免费在线阅读韩漫的乐趣。每天都有新内容，网站稳定性有保障。
              </p>
              <a
                href="/category/all"
                className="inline-block px-8 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer no-underline"
              >
                立即浏览全部漫画
              </a>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}